
import { TextType, ETextTypes } from './types'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'Text',
  props: {
    as: { type: String as PropType<TextType>, default: ETextTypes.P },
  },
})
